import { TASK_PRIORITY } from '../global/constants';

export const menuItems = [
  {
    key: TASK_PRIORITY.NO_PRIORITY,
    label: 'No Priority',
    icon: 'Priority-No-priority-icon'
  },
  {
    key: TASK_PRIORITY.URGENT,
    label: 'Urgent',
    icon: 'Priority-Urgent-icon'
  },
  {
    key: TASK_PRIORITY.HIGH,
    label: 'High',
    icon: 'Priority-High-icon'
  },
  {
    key: TASK_PRIORITY.MEDIUM,
    label: 'Medium',
    icon: 'Priority-Medium-icon'
  },
  {
    key: TASK_PRIORITY.LOW,
    label: 'Low',
    icon: 'Priority-low-icon'
  }
];

export const dueDateItems = [
  { label: 'No due date' },
  { label: 'In the past' },
  { label: '1 day from now' },
  { label: '3 day from now' },
  { label: '1 week from now' },
  { label: '1 month from now' },
  { label: '3 months from now' },
  { label: 'Custom date' }
];

export const filterOptions = {
  priority: {
    iconName: 'Priority-High-icon',
    label: 'Priority',
    viewBox: '0 0 16 16'
  },
  status: {
    iconName: 'task-status-icon',
    label: 'Status',
    viewBox: '0 0 16 16'
  },
  assign: {
    iconName: 'task-human-icon',
    label: 'Assignee',
    viewBox: '0 0 16 16'
  },
  project: {
    iconName: 'projects-icon',
    label: 'Project',
    viewBox: '0 0 24 24'
  },
  dueDate: {
    iconName: 'filter-due-date-icon',
    label: 'Due date',
    viewBox: '0 0 16 16'
  }
};
